import React from 'react';
import { Button, Icon } from 'zarm';
import cn from 'classnames';
import './index.less';
export default function ButtonAdd(props) {
  const {
    onClick,
    visible,
    noborder
  } = props;

  if (visible === false) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Button, {
    className: cn('cc-button-add', {
      noborder
    }),
    block: true,
    ghost: true,
    theme: "primary",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "add",
      theme: "success"
    }),
    onClick: onClick
  }, props.children);
}